module.exports = __webpack_public_path__ + "static/img/bg6.4bb02804.jpg";